// frontend/src/services/perfilApi.js
// Chamadas da pagina "Meu Perfil". Todas agem so no usuario logado (o servidor usa o token; nao ha id na URL).

const BASE = '/api/perfil';

function erro(mensagem, status, sessao) {
  const e = new Error(mensagem);
  e.status = status;
  e.sessaoExpirada = !!sessao;
  return e;
}

async function chamar(metodo, caminho, corpo) {
  const token = localStorage.getItem('token');
  let resposta;
  try {
    resposta = await fetch(BASE + caminho, {
      method: metodo,
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
      body: corpo === undefined ? undefined : JSON.stringify(corpo),
    });
  } catch (e) {
    throw erro('Sem conexão com o servidor. Verifique a internet e tente de novo.', 0);
  }
  let dados = null;
  try { dados = await resposta.json(); } catch (e) { dados = null; }
  if (resposta.ok) return dados;
  const texto = dados && dados.error ? String(dados.error) : '';
  // 403 = token invalido/expirado. 401 com mensagem de token/sessao = sem login. (401 com "senha atual incorreta" e outra coisa.)
  if (resposta.status === 403 || (resposta.status === 401 && (!texto || /^(Token|Sess)/i.test(texto)))) {
    throw erro('Sua sessão expirou. Entre novamente para continuar.', resposta.status, true);
  }
  throw erro(texto || 'Não foi possível concluir. Tente de novo em instantes.', resposta.status);
}

export const carregarPerfil = () => chamar('GET', '');
export const salvarFoto = (imagem) => chamar('PUT', '/foto', { imagem });
export const removerFoto = () => chamar('DELETE', '/foto');
export const trocarSenha = (senhaAtual, novaSenha) => chamar('PUT', '/senha', { senhaAtual, novaSenha });
